<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="staff_nom">Nom et Postnom</label>
        <label class="input-group-text" for="staff_postnom"></label>
      </div>
      <input id="staff_nom"
             v-model="dataForm.nom"
             class="form-control"
             name="staff_nom"
             placeholder="Entrez le nom du membre des staffs"
             type="text">
      <input id="staff_postnom"
             v-model="dataForm.postnom"
             class="form-control"
             name="staff_postnom"
             placeholder="Entrez le postnom du membre des staffs"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text" for="staff_prenom">Prenom</label>
      </div>
      <input id="staff_prenom"
             v-model="dataForm.prenom"
             class="form-control"
             name="staff_prenom"
             placeholder="Entrez le prénom du membre des staffs"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="staff_nationalite">Nationalité</label>
      </div>
      <select id="staff_nationalite"
              v-model="dataForm.nationalite"
              class="custom-select"
              name="staff_nationalite">
        <option :key="'nationalite'+idx"
                :value="nationalite.value"
                v-for="(nationalite, idx) in getNationalites">{{ nationalite.nationalites }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="staff_equipe_actuelle">Equipe actuelle</label>
      </div>
      <select id="staff_equipe_actuelle"
              v-model="dataForm.equipe_id"
              class="custom-select"
              name="staff_equipe_actuelle">
        <option :key="equipe.equipe_id.slice(5,15)"
                :value="equipe.equipe_id"
                v-for="equipe in equipes">
          {{ equipe.nom }}
        </option>
      </select>
    </div>
<!--
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="staff_equipes_passees">Equipes passées</label>
      </div>
      <select id="staff_equipes_passees"
              v-model="dataForm.equipes_passees_id"
              class="custom-select"
              multiple
              name="staff_equipes_passees">
        <option :key="equipe.equipe_id.slice(0,10)"
                :value="equipe.equipe_id"
                v-for="equipe in equipes">
          {{ equipe.nom }}
        </option>
      </select>
    </div>
-->
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="staff_fonction">Fonction</label>
      </div>
      <select id="staff_fonction"
              v-model="dataForm.fonction"
              class="custom-select"
              name="staff_fonction">
        <option :key="fonction"
                :value="fonction"
                v-for="fonction in getFonctionsStaff">
          {{ fonction }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="staff_date_naissance">Date de naissance</label>
      </div>
      <input id="staff_date_naissance"
             v-model="dataForm.date_naissance"
             class="form-control"
             name="staff_date_naissance"
             type="date">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="staff_date_debut_contrat">Date début et fin du contrat</label>
        <label class="input-group-text" for="staff_date_fin_contrat"></label>
      </div>
      <input id="staff_date_debut_contrat"
             v-model="dataForm.date_debut_contrat"
             class="form-control"
             name="staff_date_debut_contrat"
             type="date">
      <input id="staff_date_fin_contrat"
             v-model="dataForm.date_fin_contrat"
             class="form-control"
             name="staff_date_fin_contrat"
             type="date">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="fileToUpload">Photo passeport</label>
      </div>
      <input id="fileToUpload"
             ref="fileToUpload"
             @change="handleFileToUpload"
             lang="fr"
             type="file"
             class="form-control"
             accept=".png, .jpeg, .jpg">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="staff_historique">Historique</label>
      </div>
      <textarea id="staff_historique"
                v-model="dataForm.historique"
                class="form-control"
                name="staff_historique"
                placeholder="Entrez un bref historique du membre des staffs">
      </textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="staff_description">Description</label>
      </div>
      <textarea id="staff_description"
                v-model="dataForm.description"
                class="form-control"
                name="staff_description"
                placeholder="Entrez une courte description du membre des staffs">
      </textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="staff_commentaires">Commentaires</label>
      </div>
      <textarea id="staff_commentaires"
                v-model="dataForm.commentaires"
                class="form-control"
                name="staff_commentaires"
                placeholder="Entrez un court historique sur le membre des staffs">
      </textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="staff_telephone_1">Telephones</label>
        <label class="input-group-text" for="staff_telephone_2"></label>
      </div>
      <input id="staff_telephone_1"
             v-model="dataForm.telephones"
             class="form-control"
             name="staff_telephone_1"
             placeholder="Entrez le numéro prncipal du staff"
             type="tel">
      <input id="staff_telephone_2"
             v-model="dataForm.telephones"
             class="form-control"
             name="staff_telephone_2"
             placeholder="Entrez le numéro secondaire du staff"

             type="tel">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="staff_email">Email</label>
      </div>
      <input id="staff_email"
             v-model="dataForm.email"
             class="form-control"
             name="staff_email"
             placeholder="Entrez l'adresse email du staff"
             type="email">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="mr-3">Sexe : </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input"
               type="radio"
               v-model="dataForm.sexe"
               name="staff_sexe"
               id="staff_homme" value="homme">
        <label class="form-check-label rounded pl-2 pr-2" for="staff_homme">Homme</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input"
               type="radio"
               v-model="dataForm.sexe"
               name="staff_sexe"
               id="staff_femme" value="femme">
        <label class="form-check-label rounded pl-2 pr-2" for="staff_femme">Femme</label>
      </div>
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Create",
  props: {},
  data() {
    return {
      equipes: null,
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        nom: '',
        postnom: '',
        prenom: '',
        nationalite: '',
        equipe_id: '',
        equipes_passees_id: '[]',
        fonction: '',
        date_naissance: '',
        date_debut_contrat: '',
        date_fin_contrat: '',
        photo_passeport: '',
        historique: '',
        description: '',
        commentaires: '',
        telephones: '',
        email: '',
        sexe: '',
        table: 'staffs',
      },
      file: '',
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosPostData',
      'axiosPostFileData',
    ]),
    handleFileToUpload(){
      this.file = this.$refs.fileToUpload.files[0];
    },
    uploadFile () {
      let formData = new FormData()
      let fileName = ''
      if(this.dataForm.nom && this.dataForm.postnom && this.dataForm.prenom){
        fileName = this.dataForm.prenom.toLowerCase() + '_' +
            this.dataForm.postnom.toLowerCase() + '_' +
            this.dataForm.nom.toLowerCase() + '_' + Math.floor(Math.random() * 1000000) + 1
      }
      formData.append('fileToUpload', this.file)
      formData.append('fileName', fileName)
      formData.append('to', "staffs")
      if(this.file && this.file !== ''){
        this.axiosPostFileData(formData)
            .then(data => {
              this.dataForm.photo_passeport = data[2];
            })
            .catch(data => {})
      }
      this.axiosPostData(this.dataForm)
          .then((data) => {
            if((data.data.status === 'reussite' && data.status) === 201)
              this.messageSuccess = "Staff ajouté avec succès !"
            else
              this.messageFailure = "Une erreur est survenue lors de l'insertion du membre de staff !"
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de l'insertion du membre de staff !"
          })
    },
    onSubmit() {
      this.uploadFile()
    }
  },
  computed: {
    ...mapGetters([
        'getNationalites',
        'getFonctionsStaff',
    ])
  },
  beforeCreate() {
  },
  created() {
    //
    this.axiosGetAllData({
      table: 'equipes'
    })
        .then((data) => {
          this.equipes = data.data
        })
        .catch((data) => {
          this.equipes = data
        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/staffs/components/Create.vue